import storeBikeQueries from "$/lib/queries/store-bike-queries"
import storeCustomerQueries from "$/lib/queries/store-customer-queries"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const paramsSchema = z.object({
  customerId: z.string().uuid(),
})

export const Route = createFileRoute("/(app)/_auth/customers/$customerId")({
  params: {
    parse: (params) => paramsSchema.parse(params),
    stringify: ({ customerId }) => ({ customerId: `${customerId}` }),
  },
  loader: async ({ context: { queryClient }, params }) => {
    await requireNonFreeTier(queryClient)
    const [customer] = await Promise.all([
      queryClient.ensureQueryData(
        storeCustomerQueries.detail(params.customerId),
      ),
      queryClient.ensureQueryData(
        storeCustomerQueries.messages(params.customerId),
      ),
      queryClient.ensureQueryData(storeBikeQueries.list(params.customerId)),
    ])

    return {
      crumb: [customer.firstName, customer.lastName].filter(Boolean).join(" "),
    }
  },
})
